// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.S8aZfEqWl6u946KqLgpl {
  margin: 60px 32px 32px;
}`, "",{"version":3,"sources":["webpack://./src/components/HeatmappedPage/HeatmappedPage.module.scss"],"names":[],"mappings":"AAAA;EACE,sBAAA;AACF","sourcesContent":[".scoreCardStack {\n  margin: 60px 32px 32px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"scoreCardStack": `S8aZfEqWl6u946KqLgpl`
};
export default ___CSS_LOADER_EXPORT___;
